/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import CarePlansCarePlan from './CarePlansCarePlan';

/**
 * The CarePlansBody model module.
 * @module model/CarePlansBody
 * @version v0.3
 */
export default class CarePlansBody {
  /**
   * Constructs a new <code>CarePlansBody</code>.
   * @alias module:model/CarePlansBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CarePlansBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CarePlansBody} obj Optional instance to populate.
   * @return {module:model/CarePlansBody} The populated <code>CarePlansBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CarePlansBody();
      if (data.hasOwnProperty('care_plan'))
        obj.carePlan = CarePlansCarePlan.constructFromObject(data['care_plan']);
    }
    return obj;
  }
}

/**
 * @member {module:model/CarePlansCarePlan} carePlan
 */
CarePlansBody.prototype.carePlan = undefined;

